import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  slug: string;
  title: string;
  author: string;
  category: string;
  status: string;
  rating: number;
  views: number;
  chapters: number;
  coverImage: string;
  categoryName?: string;
}

export default function ComicCard({
  slug,
  title,
  author,
  status,
  rating,
  views,
  chapters,
  coverImage,
  categoryName,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${slug}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={coverImage}
          alt={title}
          title={`${title} - 好看的韩国漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded text-xs font-medium ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-700 text-background-100'
          }`}>
            {status}
          </span>
        </div>
        {categoryName && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 rounded text-xs font-medium bg-background-900/70 text-background-100 backdrop-blur-sm">
              {categoryName}
            </span>
          </div>
        )}
        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="flex items-center gap-1 text-xs text-background-100">
            <i className="ri-star-fill text-primary-400 text-xs"></i>
            {rating}
          </span>
          <span className="text-xs text-background-100">
            {chapters}话
          </span>
        </div>
      </div>
      <h3 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
        {title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <span className="text-xs text-foreground-500">{author}</span>
        <span className="text-xs text-foreground-400 flex items-center gap-1">
          <i className="ri-eye-line text-[10px]"></i>
          {formatViews(views)}
        </span>
      </div>
    </Link>
  );
}